import type {FC} from 'react';
import {memo} from 'react';

import IconClose from '@src/components/icons/IconClose/IconClose';

interface Props {
  children: any;
  className?: string;
  classNameCloseBut?: string;
  closeModalWindowContainer?: () => void;
}

const ModalWindowContainer: FC<Props> = ({
  children,
  className = '',
  classNameCloseBut = '',
  closeModalWindowContainer,
}) => {
  return (
    <div className={`ModalWindowContainer ${className}`}>
      {closeModalWindowContainer ? (
        <button
          className={`closeBut ${classNameCloseBut}`}
          onClick={closeModalWindowContainer}
        >
          <IconClose />
        </button>
      ) : (
        ''
      )}
      {children}
    </div>
  );
};

export default memo(ModalWindowContainer);
